import Fuse from 'fuse.js'
import React, { useMemo } from 'react'
import { SetterOrUpdater, useRecoilValue, useSetRecoilState } from 'recoil'

import * as userListsAtoms from 'src/atoms/user-lists'
import * as userListsModalAtoms from 'src/atoms/user-lists/user-lists-modal'
import { UserList } from 'src/common-services'
import { USER_LIST_ITEM_ICONS } from 'src/components/user-lists-modal/constants'
import {
  ListItemDescription,
  ListItemIconWrapper,
  ListItemName,
  ListItemWrapper,
  UserListsWrapper,
} from 'src/components/user-lists-modal/components'
import { ListEmptyState } from 'src/components/user-lists-modal/list-empty-state'

const renderUserLists = (selectedListSetter: SetterOrUpdater<string | null>) => (item: UserList) => {
  const Icon = USER_LIST_ITEM_ICONS.list
  return (
    <ListItemWrapper key={item.id} onClick={() => selectedListSetter(item.id)}>
      <ListItemIconWrapper>
        <Icon size={12} />
      </ListItemIconWrapper>
      <ListItemName>{item.name}</ListItemName>
      <ListItemDescription>{item.description}</ListItemDescription>
    </ListItemWrapper>
  )
}

export const UserLists: React.FC = () => {
  const filter = useRecoilValue(userListsModalAtoms.listFilter)
  const lists = useRecoilValue(userListsAtoms.userLists)
  const setSelectedListId = useSetRecoilState(userListsModalAtoms.selectedListId)
  const fuse = useMemo(
    () =>
      new Fuse(lists || [], {
        includeScore: true,
        keys: ['name'],
      }),
    [lists]
  )
  const filteredList = filter !== '' ? fuse.search(filter).map((result) => result.item) : lists || []
  if (filter && filteredList.length === 0) {
    return <ListEmptyState heading="No results found" />
  }
  if ((lists || []).length === 0) {
    return <ListEmptyState subheading="Once you start creating lists, they will appear here." />
  }
  return <UserListsWrapper>{filteredList.map(renderUserLists(setSelectedListId))}</UserListsWrapper>
}
